import React from 'react';
import Modal from './Modal';

// Conferma della chiamata.
//
// La ricerca mostra una lista di righe alte quanto un dito: con la fretta del
// proprio turno un tocco storto chiamava il giocatore sbagliato, e la chiamata
// non si annulla — parte subito l'asta per tutti, con il timer che scorre.
// Fra la riga toccata e il messaggio al server ci sta quindi una domanda.
//
// Il bottone di conferma non e' quello che riceve il fuoco all'apertura: chi
// arriva qui per sbaglio deve leggere il nome, non trovarsi Invio gia' armato.

export default function NominatePlayerModal({ player, onConfirm, onClose }) {
    if (!player) return null;

    return (
        <Modal
            open={Boolean(player)}
            title="Chiama un giocatore"
            onClose={onClose}
            footer={
                <>
                    <button type="button" className="btn btn--ghost" onClick={onClose}>
                        Annulla
                    </button>
                    <button type="button" className="btn btn--go" onClick={onConfirm}>
                        Chiama
                    </button>
                </>
            }
        >
            <p>
                Vuoi chiamare <strong>{player['Nome Completo']}</strong>?
            </p>
            <p>
                <span className="badge badge--role" data-role={player.Ruolo}>
                    {player.Ruolo}
                </span>{' '}
                {player.Squadra}
            </p>
            <p className="u-dim">
                L&apos;asta parte subito e la chiamata non si annulla.
            </p>
        </Modal>
    );
}
